import React from 'react';
import { Link } from 'react-router-dom';
import { Fragment } from 'react';
import { UserShape, TackNotificationDetailsShape, TackNotificationSelectionOptionsShape } from '../shapes';
import BeingTackedBy from './being_tacked_by';
import Comments from '../containers/comments';
import TackNotificationSelectionOptions from './tack_notification_selection_options';
import Waiting from './waiting';
import PropTypes from 'prop-types';

export default class TackNotificationDetailsCheckpointSynonyms extends React.Component {
  static propTypes = {
    loadComments: PropTypes.bool,
    user: UserShape,
    tackNotificationDetails: TackNotificationDetailsShape,
    tackNotificationSelectionOptions: TackNotificationSelectionOptionsShape,
    onFetchSelectionOptions: PropTypes.func,
    onResetSelectionOptions: PropTypes.func
  }

  componentDidMount() {
    this.props.onResetSelectionOptions();
    this.props.onFetchSelectionOptions(this.props.tackNotificationDetails.get('tackSlug'), this.props.tackNotificationDetails.get('tackInterval'));
  }

  render() {
    if (this.props.tackNotificationSelectionOptions.get('loading')) {
      return(
        <Waiting />
      )
    } else {
      return(
        <div className='tack-notification-details'>
          <div className='word'>
            <div className='item-meta'>
              <div>
                Day { this.props.tackNotificationDetails.get('day') } &middot; <BeingTackedBy tackedBy={ this.props.tackNotificationDetails.get('tackedBy') } tacksCount={ this.props.tackNotificationDetails.get('tacksCount') } />
              </div>
            </div>
          </div>
          <div className='checkpoint'>
            <p className='secondary-background instruction-text'>
              Pick the word that is <Link to='/words/synonym'>synonymous</Link> with { this.props.tackNotificationDetails.get('wordText') }.
            </p>
            <TackNotificationSelectionOptions tackNotificationSelectionOptions={ this.props.tackNotificationSelectionOptions } />
            <p className='example-text'>
              { this.props.tackNotificationDetails.get('exampleText') }
            </p>
            { this.renderComments() }
          </div>
        </div>
      );
    }
  }

  renderComments() {
    if (this.props.loadComments) {
      return (
        <Fragment>
          <div className='give-me-55-top'></div>
          <Comments wordText={ this.props.tackNotificationDetails.get('wordText') }/>
        </Fragment>
      )
    } else return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_notification_details_checkpoint_synonyms.jsx